import { type ReactElement } from 'react';
import type { SCAPIShopperProductsSchemas, SCAPIShopperStoresSchemas } from 'src/types';
import { ProductGiftProvider } from '@/providers/product-gift';
import ProductViewProvider from '@/providers/product-view';
import { EventCourseStoreInfoProvider } from '@/providers/event-course-store-info';
import EventCourseHero from './event-course-hero';
import EventCourseTabs from './event-course-tabs';
import EventCourseStoreInfoDrawer from './event-course-store-info-drawer';

interface EventCourseViewProps {
    product: SCAPIShopperProductsSchemas['Product'];
    eventOccurrences: SCAPIShopperProductsSchemas['Product'][];
    /** Store linked to the product via `c_eventStoreId`, resolved for the "Location e contatti" tab. */
    eventStore: Promise<SCAPIShopperStoresSchemas['Store'] | undefined>;
}

/**
 * PDP layout for products with `c_productType` of 'event' or 'course'.
 *
 * Composes the hero (image + booking box) with the tab strip below. Wrapped in
 * {@link ProductViewProvider} so the booking box's add-to-cart action shares the
 * same cart state (toast + mini-cart) as the standard product view.
 */
export default function EventCourseView({ product, eventOccurrences, eventStore }: EventCourseViewProps): ReactElement {
    return (
        <ProductGiftProvider>
            <ProductViewProvider product={product} mode="add">
                <EventCourseStoreInfoProvider eventStore={eventStore}>
                    <div className="flex flex-col">
                        <EventCourseHero product={product} eventOccurrences={eventOccurrences} />
                        <div className="grid-global mx-auto pt-3 px-4 lg:pt-6">
                            <div className="col-span-full min-w-0 lg:col-span-10 lg:col-start-2">
                                <EventCourseTabs product={product} eventStore={eventStore} />
                            </div>
                        </div>
                    </div>
                    <EventCourseStoreInfoDrawer />
                </EventCourseStoreInfoProvider>
            </ProductViewProvider>
        </ProductGiftProvider>
    );
}
